import React, { useLayoutEffect } from 'react';
import { Link, Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { updateStylePattern } from '../../modules/pattern';
import { RootState } from '../../rootReducer';
import { AppDispatch } from '../../store';
import urls from '../../utils/urls';

// X006
const AccountLock: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { stylePattren } = useSelector((state: RootState) => state.pattern);

  useLayoutEffect(() => {
    if (stylePattren !== 'A') {
      dispatch(updateStylePattern('A'));
    }
  }, []);

  return (
    <>
      <Route component={Header} />
      <main className="l-main">
        <section>
          <div className="blockMain mb05gd">
            <div className="blockNarrow">
              <div className="ttlH1 mtFLAT mbFLAT">
                <p className="fsXS mbFLAT mtFLAT font-SBIMA--black">会員ログイン</p>
                <h1>アカウントロック</h1>
              </div>
            </div>
          </div>
          <div className="blockSub mb05gd">
            <div className="blockNarrow">
              <div className="imgBox--center mb05gd">
                <img src="/img/A/X006/icon_01.svg" alt="" className="imgBox__img" width="100px" />
              </div>
              <p className="mbL">
                一定回数ログインに失敗したため、セキュリティ保護の観点からアカウントをロックしました。
                ロックを解除するには、「ID/パスワードを再設定する」ボタンより、再設定をお願いします。
              </p>
              <div className="flexC mbFLAT">
                <Link to={urls.X008} className="btn btn--cv">ID/パスワードを再設定する</Link>
              </div>
            </div>
          </div>
          <div className="blockSub mb05gd">
            <div className="ttlH2">
              <h2>よくあるご質問</h2>
            </div>
            <div className="blockNarrow blockNarrow--S">
              <div className="accordionList accordionList--noTopBd mbFLAT">
                <Accordion className="accordionList__item">
                  <AccordionSummary className="accordionList__item__ttl">
                    <span className="icon--Q">会員ページへログインできません。</span>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div className="icon--A">
                      <p className="mtFLAT font-SBIMA--black">
                        ■はじめてお申込みのお客さま
                      </p>
                      <p className="font-SBIMA--black">
                        ご契約が完了後、ログインが可能になります。
                        会員ログインページの<Link to={urls.X008}>ID/パスワード設定</Link>よりIDとパスワードの設定をお願いします。
                      </p>
                      <p className="font-SBIMA--black">
                        ■会員のお客さま
                      </p>
                      <p className="mbFLAT font-SBIMA--black">
                        はじめてログインいただく際には、新しいIDとパスワードの設定が必要となります。設定済みにもかかわらずログインできない、設定したIDとパスワードをお忘れの場合は会員ログインページの<Link to={urls.X008}>ID/パスワード設定</Link>より再設定をお願いします。
                      </p>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Route component={Footer} />
    </>
  );
};

export default AccountLock;
